import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for orders hooks
 * Keys match backend controller method names
 */
export const ordersKeys = {
  findAll: (params?: QueryParamsDto) => ["orders", "findAll", params] as const,
  findOne: (id: string) => ["orders", "findOne", id] as const,
} as const
